import { render, staticRenderFns } from "./singleCoup.vue?vue&type=template&id=3c5df4f2&scoped=true&"
import script from "./singleCoup.vue?vue&type=script&lang=ts&"
export * from "./singleCoup.vue?vue&type=script&lang=ts&"
import style0 from "./singleCoup.vue?vue&type=style&index=0&id=3c5df4f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5df4f2",
  null
  
)

export default component.exports